export const extractAcronym = (data: string) =>
	data
		.match(/(^.)| (.)/g)
		.map((v) => v.trim())
		.filter((v, i) => i < 2)
		.map((v) => v.toUpperCase())
		.join('');
